import camelCase from 'lodash/camelCase';
import { Link, LinkProps } from '~/components/link';
import { ContractVersion } from '~/typings/context';
import { IS_PERCH_ENERGY, TERMS_URL } from '~/utils/constants';
import { determineLanguage } from '~/utils/funnels';
import { ContractLinkScreen, EventName, Logger } from '~/utils/logger';

// Simple contract link that redirects to Catbird
export const ContractLink = ({
  contract,
  linkProps,
  screen,
}: {
  contract: ContractVersion;
  linkProps?: LinkProps;
  screen: ContractLinkScreen;
}) => {
  const language = determineLanguage() || 'en';
  const href = `${TERMS_URL}?id=${contract.id}&lang=${language}&entity=${
    IS_PERCH_ENERGY ? 'perch' : 'arcadia'
  }`;
  const handleOnClick = () => {
    if (!IS_PERCH_ENERGY) return;
    // Status-less append: opening a preview is an attribute of the screen, not a
    // lifecycle transition, so it must never re-render a completed screen.
    // (SUBEXP-3193)
    Logger.logEvent(
      screen === EventName.LegalScreen
        ? { contractPreviewOpened: true }
        : { [`${camelCase(contract.displayName)}Clicked`]: true },
      screen,
    );
  };

  return (
    <Link
      color="primary"
      onClick={handleOnClick}
      id={`ContractVersion-${contract.id}`}
      href={href}
      {...linkProps}
    >
      {contract.displayName}
    </Link>
  );
};
